module.exports = __webpack_public_path__ + "static/media/exyookay-help-support.ef55a825.png";